import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { IconButton, Tooltip } from '@mui/material';
import { GradeScale } from '../../../types/gradeScaleType';
import Icons from '../../../components/icons';

const gradeScaleColumns = (
  setEditScale: (scale: GradeScale) => void,
  setDeleteGradeScale: (scale: GradeScale) => void
): GridColDef[] => [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1
  },
  {
    field: 'edit',
    headerName: 'Edit',
    sortable: false,
    maxWidth: 160,
    minWidth: 160,
    renderCell: (params) =>
      React.createElement(Tooltip, {
        title: 'View / Edit',
        children: React.createElement(
          IconButton,
          { onClick: () => setEditScale(params.row as GradeScale) },
          React.createElement(Icons.EditBlackOutlined, null)
        )
      })
  },
  {
    field: 'delete',
    headerName: 'Delete',
    sortable: false,
    maxWidth: 160,
    minWidth: 160,
    renderCell: (params) =>
      React.createElement(Tooltip, {
        title: 'Delete',
        children: React.createElement(
          IconButton,
          { onClick: () => setDeleteGradeScale(params.row as GradeScale) },
          React.createElement(Icons.Delete, { width: 20, height: 20 })
        )
      })
  }
];

export { gradeScaleColumns };
